import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { QUERY_GET_FEATURE_FLAGS } from "services/graphQL/ciq-queries";

interface ProductEntitlement {
  id: number;
  feature: string;
}

interface ProjectProductEntitlement {
  enabled: boolean;
  enable_for_new_project: boolean;
  product_entitlement: ProductEntitlement;
}

interface SubscriptionProductEntitlement {
  enabled: boolean;
  product_entitlement: ProductEntitlement;
}

interface SubscriptionFutureProjectsEntitlement {
  enable_for_future_projects: boolean;
  product_entitlement: ProductEntitlement;
}

interface Project {
  id: string;
  name: string;
  project_product_entitlements: ProjectProductEntitlement[];
}

interface Subscription {
  id: string;
  name: string;
  projects_owned: Project[];
  subscription_product_entitlements: SubscriptionProductEntitlement[];
  future_projects_entitlements: SubscriptionFutureProjectsEntitlement[];
}

interface FeatureFlagsData {
  subscription: Subscription[];
}

interface UseFeatureFlagsParams {
  organizationId: string;
  skip?: boolean;
}

interface UseFeatureFlagsReturn {
  data: FeatureFlagsData | undefined;
  loading: boolean;
  error: any;
  refetch: () => void;
}

export const useFeatureFlags = ({
  organizationId,
  skip = false
}: UseFeatureFlagsParams): UseFeatureFlagsReturn => {
  const { data, loading, error, refetch } = useCIQQuery<FeatureFlagsData>(
    QUERY_GET_FEATURE_FLAGS,
    {
      variables: {
        orgId: organizationId
      },
      skip: skip || !organizationId,
      fetchPolicy: "no-cache"
    }
  );

  return {
    data,
    loading,
    error,
    refetch
  };
};
